// src/config/rolePermissions.js
// File cấu hình mapping giữa roleType và danh sách quyền
// Sử dụng: Khi user có roleType khác CUSTOM, hệ thống sẽ lấy danh sách quyền từ file này thay vì từ JWT authorities
// Ví dụ: checkPermission() sẽ dùng config này để kiểm tra quyền cho các role cố định

const ROLE_PERMISSIONS = {
    // Quản trị hệ thống - Có tất cả quyền
    ADMIN_SYSTEM: [
        // Dashboard
        "QLTS_CUSTOMER_REPORT",

        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Hệ thống
        "SCHOOL_LIST", "YEAR_LIST", "GROUP_USER_LIST", "USER_LIST",
        "DEPARTMENT_LIST", "CLASS_LIST", "SUBJECT_LIST",

        // Quản lý học sinh
        "STUDENT_LIST", "STUDENT_CREATE", "STUDENT_EDIT", "STUDENT_DELETE",
        "STUDENT_IMPORT", "STUDENT_EXPORT",

        // Quản lý giáo viên
        "TEACHER_LIST", "TEACHER_CREATE", "TEACHER_EDIT", "TEACHER_DELETE",

        // Quản lý phụ huynh
        "PARENT_LIST", "PARENT_CREATE", "PARENT_EDIT", "PARENT_DELETE",

        // Quản lý lớp học
        "CLASS_MANAGEMENT", "SCHEDULE_MANAGEMENT",

        // Quản lý điểm
        "GRADE_LIST", "GRADE_INPUT", "GRADE_EXPORT",

        // Quản lý thực đơn
        "FO0", "FO1", "FO2", "FO3", "FOE0", "FOE1", "FOE2",
        "M0", "M1", "M2", "MW0", "MW1", "MW4",

        // Quản lý y tế
        "S0", "Y0", "GU0", "U0",

        // Quản lý Email
        "EMAIL0", "EMAIL1", "EMAIL2", "EMAIL3", "EMAIL4",  // Email inbox
        "EMAC0", "EMAC1", "EMAC2", "EMAC3", "EMAC6",       // Email account
        "EMTP0", "EMTP1", "EMTP2", "EMTP3", "EMTP4",       // Email template
        "EMLB0", "EMLB1", "EMLB2", "EMLB3",                // Email label
        "EMCF0", "EMCF1", "EMCF2", "EMCF3",                // Email config (auto recipient)

        // Báo cáo
        "REPORT_STUDENT", "REPORT_TEACHER", "REPORT_FINANCE",

        // Cài đặt hệ thống
        "SYSTEM_CONFIG", "BACKUP_RESTORE"
    ],

    // Quản trị trường học - Có hầu hết quyền trừ cài đặt hệ thống
    ADMIN_SCHOOL: [
        "OF0",
        // Dashboard
        "QLTS_CUSTOMER_REPORT",

        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Hệ thống (trừ quản lý trường)
        "YEAR_LIST", "GROUP_USER_LIST", "USER_LIST",
        "DEPARTMENT_LIST", "CLASS_LIST", "SUBJECT_LIST",

        // Quản lý học sinh
        "STUDENT_LIST", "STUDENT_CREATE", "STUDENT_EDIT", "STUDENT_DELETE",
        "STUDENT_IMPORT", "STUDENT_EXPORT",

        // Quản lý giáo viên
        "TEACHER_LIST", "TEACHER_CREATE", "TEACHER_EDIT", "TEACHER_DELETE",

        // Quản lý phụ huynh
        "PARENT_LIST", "PARENT_CREATE", "PARENT_EDIT", "PARENT_DELETE",

        // Quản lý lớp học
        "CLASS_MANAGEMENT", "SCHEDULE_MANAGEMENT",

        // Quản lý điểm
        "GRADE_LIST", "GRADE_INPUT", "GRADE_EXPORT",

        // Quản lý thực đơn
        "FO0", "FO1", "FO2", "FO3", "FOE0", "FOE1", "FOE2",
        "M0", "M1", "M2", "MW0", "MW1", "MW4",

        // Quản lý y tế
        "S0", "Y0", "GU0", "U0",

        // Quản lý Email
        "EMAIL0", "EMAIL1", "EMAIL2", "EMAIL3", "EMAIL4",  // Email inbox
        "EMAC0", "EMAC1", "EMAC2", "EMAC3", "EMAC6",       // Email account
        "EMTP0", "EMTP1", "EMTP2", "EMTP3", "EMTP4",       // Email template
        "EMLB0", "EMLB1", "EMLB2", "EMLB3",                // Email label
        "EMCF0", "EMCF1", "EMCF2", "EMCF3",                // Email config (auto recipient)

        // Báo cáo
        "REPORT_STUDENT", "REPORT_TEACHER", "REPORT_FINANCE"
    ],

    // Hiệu trưởng - Tập trung vào quản lý và báo cáo cấp cao
    PRINCIPAL_SCHOOL: [
        "OF0",
        // Dashboard
        "QLTS_CUSTOMER_REPORT",

        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Quản lý cơ bản
        "STUDENT_LIST", "TEACHER_LIST", "PARENT_LIST", "CLASS_LIST",

        // Báo cáo và thống kê
        "REPORT_STUDENT", "REPORT_TEACHER", "REPORT_FINANCE",

        // Quản lý lớp học và lịch
        "CLASS_MANAGEMENT", "SCHEDULE_MANAGEMENT",

        // Quản lý điểm (xem)
        "GRADE_LIST", "GRADE_EXPORT",

        // Quản lý thực đơn (xem và duyệt)
        "M0", "MW0", "MW4"
    ],

    // Ban giám hiệu - Tương tự hiệu trưởng nhưng ít quyền hơn
    BAN_GIAM_HIEU: [
        "OF0",
        // Dashboard
        "QLTS_CUSTOMER_REPORT",

        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Quản lý cơ bản (chỉ xem)
        "STUDENT_LIST", "TEACHER_LIST", "CLASS_LIST",

        // Báo cáo
        "REPORT_STUDENT", "REPORT_TEACHER",

        // Quản lý lớp học
        "CLASS_MANAGEMENT", "SCHEDULE_MANAGEMENT",

        // Quản lý điểm (xem)
        "GRADE_LIST",

        // Thực đơn (xem)
        "M0", "MW0"
    ],

    // Giáo vụ - Tập trung vào việc quản lý học tập
    GIAO_VU: [
        "OF0",
        // Dashboard
        "QLTS_CUSTOMER_REPORT",

        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Quản lý học sinh
        "STUDENT_LIST", "STUDENT_CREATE", "STUDENT_EDIT", "STUDENT_IMPORT", "STUDENT_EXPORT",

        // Quản lý giáo viên
        "TEACHER_LIST", "TEACHER_CREATE", "TEACHER_EDIT",

        // Quản lý lớp học và môn học
        "CLASS_LIST", "CLASS_MANAGEMENT", "SUBJECT_LIST", "SCHEDULE_MANAGEMENT",

        // Quản lý điểm
        "GRADE_LIST", "GRADE_INPUT", "GRADE_EXPORT",

        // Báo cáo học tập
        "REPORT_STUDENT"
    ],

    // Giáo viên - Chỉ có quyền liên quan đến lớp mình dạy
    GiaoVien: [
        // Điểm danh
        "AD0|TB0|AE0|ALP0|AC0|ADRRT|ARERT",
        // Quản lý cán bộ
        "OF0",
        // Quản lý tài khoản
        "S2",
        "TB0",
        "QCA6",
        "QCA6",
        "A2",
        "N0",
        "NE0",
        "AD0|TB0|AE0|ALP0|AC0|ADRRT|ARERT",
        "AE0|ET0|ER0",
        "P0|PC0",
        "SM0|EM0",
        "QC0|QCA0|QCG0",
        "S0|Y0|GU0|U0",//"Chấm công"

        // Xem danh sách học sinh (lớp mình dạy)
        "STUDENT_LIST",

        // Quản lý điểm (lớp mình dạy)
        "GRADE_LIST", "GRADE_INPUT",

        // Xem lịch dạy
        "SCHEDULE_MANAGEMENT",

        // Quản lý thực đơn
        "FO0", "FO1", "FO2", "FO3", "FOE0", "FOE1", "FOE2",
        "M0", "M1", "M2", "MW0", "MW1", "MW4",

        // Quản lý y tế
        "S0", "Y0", "GU0", "U0",

        // Quản lý Email
        "EMAIL0", "EMAIL1", "EMAIL2", "EMAIL3", "EMAIL4",  // Email inbox
        "EMAC0", "EMAC1", "EMAC2", "EMAC3", "EMAC6",       // Email account
        "EMTP0", "EMTP1", "EMTP2", "EMTP3", "EMTP4",       // Email template
        "EMLB0", "EMLB1", "EMLB2", "EMLB3",                // Email label
        "EMCF0", "EMCF1", "EMCF2", "EMCF3",                // Email config (auto recipient)
    ],

    // Giáo viên ngoài - Quyền hạn chế hơn giáo viên chính thức
    GIAO_VIEN_NGOAI: [
        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Xem danh sách học sinh (lớp được phân công)
        "STUDENT_LIST",

        // Quản lý điểm (hạn chế)
        "GRADE_LIST", "GRADE_INPUT",

        // Xem lịch dạy
        "SCHEDULE_MANAGEMENT"
    ],

    // Hành chính vận hành - Quản lý các dịch vụ hành chính
    HANH_CHINH_VAN_HANH: [
        // Quản lý cán bộ
        "OF0",
        // Dashboard
        "QLTS_CUSTOMER_REPORT",

        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Quản lý thực đơn
        "FO0", "FO1", "FO2", "FO3", "FOE0", "FOE1", "FOE2",
        "M0", "M1", "M2", "MW0", "MW1", "MW4",

        // Quản lý y tế
        "S0", "Y0", "GU0", "U0",

        // Quản lý Email
        "EMAIL0", "EMAIL1", "EMAIL2", "EMAIL3", "EMAIL4",  // Email inbox
        "EMAC0", "EMAC1", "EMAC2", "EMAC3", "EMAC6",       // Email account
        "EMTP0", "EMTP1", "EMTP2", "EMTP3", "EMTP4",       // Email template
        "EMLB0", "EMLB1", "EMLB2", "EMLB3",                // Email label
        "EMCF0", "EMCF1", "EMCF2", "EMCF3",                // Email config (auto recipient)

        // Quản lý cơ sở vật chất và dịch vụ
        "list_wallet", "management_new_accounts_registered_to_the_platform",
        "management_email", "management_sms"
    ],

    // Tuyển sinh - Chỉ quản lý tuyển sinh
    TUYEN_SINH: [
        "OF0",
        // Quản lý tài khoản
        "ACCOUNT_EDIT_PROFILE",

        // Quản lý hồ sơ tuyển sinh
        "management_new_accounts_registered_to_the_platform",

        // Quản lý học sinh mới
        "STUDENT_LIST", "STUDENT_CREATE", "STUDENT_IMPORT"
    ],

    // Học sinh - Chỉ xem thông tin của mình
    HOC_SINH: [
        // Quản lý tài khoản cá nhân
        "ACCOUNT_EDIT_PROFILE",

        // Xem điểm của mình
        "GRADE_LIST",

        // Xem thực đơn
        "M0", "MW0",

        // Xem lịch học
        "SCHEDULE_MANAGEMENT"
    ],

    // Học sinh ngoài - Quyền hạn chế hơn học sinh chính thức
    HOC_SINH_NGOAI: [
        // Quản lý tài khoản cá nhân
        "ACCOUNT_EDIT_PROFILE",

        // Xem thực đơn
        "M0", "MW0"
    ],

    // Phụ huynh - Xem thông tin con em
    PHU_HUYNH: [
        // Quản lý tài khoản cá nhân
        "ACCOUNT_EDIT_PROFILE",

        // Xem thông tin học sinh (con em)
        "STUDENT_LIST",

        // Xem điểm con em
        "GRADE_LIST",

        // Xem thực đơn
        "M0", "MW0",

        // Xem lịch học con em
        "SCHEDULE_MANAGEMENT",

        // Thanh toán dịch vụ
        "list_wallet"
    ]
};

/**
 * Lấy danh sách quyền theo roleType
 * @param {string} roleType - Loại role (VD: ADMIN_SYSTEM, GIAO_VIEN, ...)
 * @returns {Array} Danh sách quyền
 */
export function getPermissionsByRole(roleType) {
    return ROLE_PERMISSIONS[roleType] || [];
}

/**
 * Kiểm tra roleType có hợp lệ không
 * @param {string} roleType - Loại role cần kiểm tra
 * @returns {boolean} True nếu roleType hợp lệ
 */
export function isValidRoleType(roleType) {
    return Object.keys(ROLE_PERMISSIONS).includes(roleType);
}

/**
 * Lấy tất cả roleTypes có sẵn
 * @returns {Array} Danh sách tất cả roleTypes
 */
export function getAllRoleTypes() {
    return Object.keys(ROLE_PERMISSIONS);
}

export default ROLE_PERMISSIONS;
